import React from 'react';
import { Heart, Sparkles } from 'lucide-react';
import { images } from '../data/mockData';

const WelcomeSection = () => (
  <section className="relative overflow-hidden bg-[#160728] py-20 text-white sm:py-28">
    <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_20%,rgba(250,190,35,0.12),transparent_25%),radial-gradient(circle_at_80%_80%,rgba(113,48,190,0.28),transparent_32%)]" />
    <div className="relative z-10 mx-auto grid max-w-7xl items-center gap-12 px-4 sm:px-6 lg:grid-cols-[0.65fr_1.35fr] lg:px-8">
      <div className="flex justify-center">
        <img
          src={images.wisdomLogo}
          alt="The Wisdom Network"
          className="w-56 drop-shadow-[0_16px_35px_rgba(250,204,21,0.18)] sm:w-72"
          loading="lazy"
          decoding="async"
        />
      </div>
      <div>
        <p className="mb-5 text-xs font-semibold uppercase tracking-[0.35em] text-yellow-300/80">Welcome to The Wisdom Network</p>
        <h2 className="font-title text-4xl font-bold text-yellow-300 sm:text-5xl">
          A home for your journey.
        </h2>
        <p className="mt-7 text-lg leading-8 text-white/75">
          Where you connect with the absolute best in spiritual life coaching, hypnotherapy, metaphysical healing, psychic reading, and herbalism, all trained in techniques and ways of working with power that exist entirely outside the mainstream, and where you find a community that holds you in between.
        </p>
        <div className="mt-9 border-t border-white/15 pt-7">
          <div className="flex items-center gap-3 text-yellow-300">
            <Heart className="h-5 w-5" />
            <h3 className="font-subtitle text-sm font-bold uppercase tracking-[0.2em]">Our Mission</h3>
          </div>
          <p className="mt-4 text-xl leading-8 text-white">
            To give people a real home for growth, healing, and transformation, built on genuine wisdom and genuine connection.
          </p>
        </div>
      </div>
    </div>
    <Sparkles className="absolute bottom-12 right-12 h-10 w-10 text-yellow-300/20" />
  </section>
);

export default WelcomeSection;